// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/style/index.scss
// module id = 518
// module chunks = 0